import { render, staticRenderFns } from "./index-router.vue?vue&type=template&id=4afec410&scoped=true"
import script from "./index-router.vue?vue&type=script&lang=js"
export * from "./index-router.vue?vue&type=script&lang=js"
import style0 from "./index-router.vue?vue&type=style&index=0&id=4afec410&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afec410",
  null
  
)

export default component.exports